import { createOfflineVisitsStorage } from '@app-worker/shared/visit/offlineVisits/offlineVisitsStorage/createOfflineVisitsStorage';

/**
 * The one store the visits list writes and logout clears. A module-level
 * instance so the visits list's save effect does not re-run every render.
 */
export const offlineVisitsStorage = createOfflineVisitsStorage();
